import { useState, useEffect } from 'react';
import { getPageViewId } from '@fundera/fundera-utilities';

const usePageViewId = () => {
  const [pageViewId, setPageViewId] = useState(null);

  useEffect(() => {
    if (pageViewId) return;
    setPageViewId(getPageViewId());
  }, [pageViewId]);

  return pageViewId;
};

export default usePageViewId;
